import * as React from 'react'
import Image from 'next/image'
import { Container } from './Container'
import { Button } from './Button'
import bgImage from '../../public/img/nubrakes-van-house-800-num@3x.jpg'

type Props = {
  title: string
  subheading: string
  buttonText: string
}
export const BecomeTechnicianTitleSection: React.FC<Props> = ({ title, subheading, buttonText }) => {
  return (
    <section className="py-0 text-white">
      <div
        className="flex flex-col justify-center align-center"
        style={{ height: '60vh', position: 'relative', width: '100%' }}
      >
        <Image src={bgImage} placeholder="blur" layout={'fill'} objectFit="cover" objectPosition="bottom center" />
        <div
          id="overlay"
          style={{
            minHeight: '100%',
            width: '100%',
            position: 'absolute',
            zIndex: 1,
            backgroundColor: 'rgba(0,0,0,.75)',
          }}
        />
        <div style={{ zIndex: 2 }}>
          <Container className="text-center">
            <h1 className="title">{title}</h1>
            <p className={`subheading`}>{subheading}</p>
            <a href={'https://apply.workable.com/nubrakes'}>
              <Button className="px-8">{buttonText}</Button>
            </a>
          </Container>
        </div>
      </div>
    </section>
  )
}
